import createReducer from "../common"
import DETAIL_INITIAL_STATE from "./state"

const id = "general"

const SET_SHARED_RESULT = `${id}/SHARED_RESULT`
const SET_REFER = `${id}/SET_REF`
const SET_ENTRANCE_TIME = `${id}/SET_ENTRANCE_TIME`
const SET_ANSWER = `${id}/SET_ANSWER`
const SET_LANG = `${id}/SET_LANG`

export const setSharedResult = (sharedResult) => ({ type: SET_SHARED_RESULT, sharedResult })
export const setRefer = (refer) => ({ type: SET_REFER, refer })
export const setEntranceTime = () => ({ type: SET_ENTRANCE_TIME })
export const setAnswer = (qIndex, value) => ({ type: SET_ANSWER, qIndex, value })
export const setLang = (lang) => ({ type: SET_LANG, lang })

const reducer = createReducer(DETAIL_INITIAL_STATE, {
  [SET_SHARED_RESULT]: (state, action) => (state.sharedResult = action.sharedResult),
  [SET_REFER]: (state, action) => (state.refer = action.refer),
  [SET_ENTRANCE_TIME]: (state) => (state.entranceTime = new Date()),
  [SET_ANSWER]: (state, action) => (state.answer[action.qIndex] = action.value),
  [SET_LANG]: (state, action) => (state.lang = action.lang),
})

export default reducer
